import axios from "axios";

import console from "../utils/functions/console";
import sendError from "../utils/functions/sendError";
import CONFIG from "../config";
import { RESPONSE_HEADER } from "../utils/enums";

export const fetchBaseData = (axiosObject) => async dispatch => {
  const url = axiosObject.url || axiosObject.restRoot + CONFIG.Admin.sorten.basedata;
  let axiosCall = axios;
  if (!axiosObject.url) { // call from administration
    // ignore interceptors for this call
    axiosCall = axios.create();
    if (axiosObject.json && axiosObject.json.header) {
      axiosObject.json.header.applikationId = CONFIG.Admin.sorten.appId;
    }
    try {
      const reqestHeader = axiosObject.request.config.headers.request;
      if (reqestHeader) {
        let newRequestHeader = JSON.parse(reqestHeader);
        newRequestHeader.applikationId = CONFIG.Admin.sorten.appId;
        axiosCall.defaults.headers.common["request"] = JSON.stringify(newRequestHeader);
      } else if (axiosObject.json && axiosObject.json.header) {
        axiosCall.defaults.headers.common["request"] = JSON.stringify(axiosObject.json.header);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const response = await axiosCall[axiosObject.request.type](url, axiosObject.json, axiosObject.request.config)
    .catch(error => {
      sendError(error, "katalog");
    });
  if (response && response.data && response.data.header && response.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
    const data = await dispatch(setBaseData(response.data));
    return data.items;
  } else if (response && response.data && response.data.header && response.data.header.status === RESPONSE_HEADER.STATUS.ERROR) {
    if (response.data.header.errorNr === RESPONSE_HEADER.ERRORNUMMER.KATALOG_FEHLER) {
      console.log(RESPONSE_HEADER);
      throw new Error(RESPONSE_HEADER.ERROR[RESPONSE_HEADER.ERRORNUMMER.KATALOG_FEHLER]);
    }
    throw new Error("e8: Ein Übertragungsfehler ist aufgetreten");
  } else {
    console.log("e7", response && response.data);
    sendError(new Error(JSON.stringify(response ? response.data : "no response")), "katalog");
    throw new Error("e7: Ein Übertragungsfehler ist aufgetreten");
  }
};

export const fetchListData = (axiosObject) => async dispatch => {
  const url = axiosObject.url || axiosObject.restRoot + CONFIG.Admin.sorten.catalog;
  let axiosCall = axios;
  if (!axiosObject.url && axiosObject.json && axiosObject.json.header) {
    axiosCall = axios.create();
    axiosObject.json.header.applikationId = CONFIG.Admin.sorten.appId;
    try {
      const reqestHeader = axiosObject.request.config.headers.request;
      if (reqestHeader) {
        let newRequestHeader = JSON.parse(reqestHeader);
        newRequestHeader.applikationId = CONFIG.Admin.sorten.appId;
        axiosCall.defaults.headers.common["request"] = JSON.stringify(newRequestHeader);
      } else if (axiosObject.json && axiosObject.json.header) {
        axiosCall.defaults.headers.common["request"] = JSON.stringify(axiosObject.json.header);
      }
    } catch (e) {
      console.log(e);
    }
  }
  const response = await axiosCall[axiosObject.request.type](url, axiosObject.json, axiosObject.request.config);
  if (response && response.data && response.data.header && response.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
    const data = await dispatch(setListData(response.data.sortenKurse));
    return data.sortenKurse;
  } else {
    console.log("e8", response && response.data);
    throw new Error("e8: Ein Übertragungsfehler ist aufgetreten");
  }
};

export function setData(basedata, sortenKurse) {
  if (!basedata || !sortenKurse) return {
    type: "ERROR",
    payload: {
      error: new Error("Es stehen nicht alle Daten zur Verfügung")
    }
  };
  return {
    type: "CURRENCIES_SET_DATA",
    payload: {
      basedata: basedata,
      listeSorte: sortenKurse.listeSorte || [],
      timeStampSortenLieferung: sortenKurse.timeStampSortenLieferung
    }
  };
}

export function setBaseData(basedata) {
  if (!basedata) return {
    type: "ERROR",
    payload: {
      error: new Error("Es stehen nicht alle Daten zur Verfügung")
    }
  };
  return {
    type: "CURRENCIES_SET_BASE_DATA",
    payload: {
      basedata: basedata
    }
  };
}

export function setListData(sortenKurse) {
  if (!sortenKurse) return {
    type: "ERROR",
    payload: {
      error: new Error("Es stehen nicht alle Daten zur Verfügung")
    }
  };
  return {
    type: "CURRENCIES_SET_LIST_DATA",
    payload: {
      listeSorte: sortenKurse.listeSorte || [],
      timeStampSortenLieferung: sortenKurse.timeStampSortenLieferung
    }
  };
}

export function resetData() {
  return {
    type: "CURRENCIES_RESET_DATA"
  };
}
